module.exports = __webpack_public_path__ + "shell/assets/images/providers/amazonec2-black.svg";